import { ExtendedStepData } from 'utils/progressIndicatorHelpers'

// pathList is an array that contains any matching urls
const postQuoteStepsResolver = {
  overview: [
    '/additional-questions/ownership',
    '/resume-from-email',
    '/direct',
    '/uswitch',
    '/compare-the-market',
    '/go-compare',
    '/confused',
    '/quotezone',
    '/money-supermarket',
    '/plan-comparison',
    '/overview',
    '/vehicle-verification',
  ],
  'add-on': ['/add-on/general', '/add-on/breakdown'],
  account: [
    '/additional-questions/licence-country',
    '/additional-questions/ncd',
    '/additional-questions/student',
    '/additional-questions',
    '/additional-questions/previous-cancellation',
    '/additional-questions/previous-cancellation-year',
    '/create-account',
    '/statements',
  ],
  summary: [
    '/summary',
    '/connect-your-bank',
    '/connect-your-bank-retry',
    '/connect-your-bank/wrong-account',
  ],
  payment: ['/payment/monthly', '/payment/annual'],
}

export const postQuoteOptions: Array<ExtendedStepData> = [
  {
    label: 'Cover',
    id: 'overview',
    pathlist: postQuoteStepsResolver.overview,
  },
  {
    label: 'Add-ons',
    id: 'add-on',
    pathlist: postQuoteStepsResolver['add-on'],
  },
  {
    label: 'Account',
    id: 'account',
    pathlist: postQuoteStepsResolver.account,
  },
  {
    label: 'Review',
    id: 'summary',
    pathlist: postQuoteStepsResolver.summary,
  },
  {
    label: 'Pay',
    id: 'payment',
    pathlist: postQuoteStepsResolver.payment,
  },
]

export const removeStepsOptions: Array<ExtendedStepData> = [
  {
    label: 'Cover',
    id: 'overview',
    pathlist: postQuoteStepsResolver.overview,
  },
  {
    label: 'Account',
    id: 'account',
    pathlist: postQuoteStepsResolver.account,
  },
  {
    label: 'Review',
    id: 'summary',
    pathlist: postQuoteStepsResolver.summary,
  },
  {
    label: 'Pay',
    id: 'payment',
    pathlist: postQuoteStepsResolver.payment,
  },
]
